"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SzDatePicker = void 0;

var react_1 = __importDefault(require("react"));

var react_date_picker_1 = __importDefault(require("react-date-picker"));

var SzIcon_1 = __importDefault(require("../SzIcon/SzIcon"));

var classnames_1 = __importDefault(require("classnames"));

require("./SzDatePicker.scss");

exports.SzDatePicker = function (_a) {
  var _b = _a.dateRange,
      dateRange = _b === void 0 ? false : _b,
      startDate = _a.startDate,
      endDate = _a.endDate,
      startMinDate = _a.startMinDate,
      endMinDate = _a.endMinDate,
      onChangeStartDate = _a.onChangeStartDate,
      onChangeEndDate = _a.onChangeEndDate,
      classNameStartDate = _a.classNameStartDate,
      classNameEndDate = _a.classNameEndDate,
      _c = _a.minDetail,
      minDetail = _c === void 0 ? 'year' : _c,
      maxDetail = _a.maxDetail,
      maxDate = _a.maxDate,
      maxEndDate = _a.maxEndDate,
      _d = _a.format,
      format = _d === void 0 ? 'dd/MM/yyyy' : _d;
  var datePickerStartClassName = classnames_1.default({
    'sz-datepicker__single': !dateRange,
    'sz-datepicker__start': dateRange
  }, classNameStartDate);
  var datePickerEndClassName = classnames_1.default('sz-datepicker__end pl-2', classNameEndDate);
  var calendarChevronIcon = react_1.default.createElement(react_1.default.Fragment, null, react_1.default.createElement(SzIcon_1.default, {
    icon: "calendar-3",
    variant: "line",
    className: "mr-2"
  }), react_1.default.createElement(SzIcon_1.default, {
    icon: "arrow-down-1",
    variant: "bold",
    className: "small pt-2"
  }));
  return react_1.default.createElement("div", {
    className: "sz-datepicker row"
  }, react_1.default.createElement(react_date_picker_1.default, {
    onChange: onChangeStartDate,
    value: startDate,
    className: datePickerStartClassName,
    calendarIcon: calendarChevronIcon,
    clearIcon: null,
    minDetail: minDetail,
    maxDetail: maxDetail,
    minDate: startMinDate,
    maxDate: maxDate,
    format: format
  }), dateRange && react_1.default.createElement(react_date_picker_1.default, {
    onChange: onChangeEndDate,
    value: endDate,
    className: datePickerEndClassName,
    calendarIcon: calendarChevronIcon,
    clearIcon: null,
    minDetail: minDetail,
    maxDetail: maxDetail,
    maxDate: maxEndDate,
    minDate: endMinDate,
    format: format
  }));
};

exports.default = exports.SzDatePicker;